/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Index_Group_DescriptionInputs */

const en_directory_taxonomy_index_group_description = /** @type {(inputs: Directory_Taxonomy_Index_Group_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use broad categories to understand the directory, then narrow your search through their sub-categories.`)
};

const zh_directory_taxonomy_index_group_description = /** @type {(inputs: Directory_Taxonomy_Index_Group_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通过宽泛分类了解目录结构，再进入其中的子分类缩小搜索范围。`)
};

/**
* | output |
* | --- |
* | "Use broad categories to understand the directory, then narrow your search through their sub-categories." |
*
* @param {Directory_Taxonomy_Index_Group_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_index_group_description = /** @type {((inputs?: Directory_Taxonomy_Index_Group_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Index_Group_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_index_group_description(inputs)
	return zh_directory_taxonomy_index_group_description(inputs)
});
export { directory_taxonomy_index_group_description as "directory.taxonomy_index.group.description" }